import React, { Component } from 'react'
import { Card, Button } from 'react-bootstrap'
import * as actions from '../actions'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import { CircularProgress } from '@material-ui/core'
import { FORM_EDICION_COEM } from '../../../config/forms'
import { parseEntityId } from '../../../models/entity'
import CamposCoemCierreDeCarga from './CamposCoemCierreDeCarga'
import moment from 'moment'

const selector = formValueSelector(FORM_EDICION_COEM)
class DialogoCOEMsUpdate extends Component {
  constructor (props) {
    super(props)
    this.updateCierreCumplido = this.updateCierreCumplido.bind(this)
    this.changeEmbarque = this.changeEmbarque.bind(this)
  }

  async componentDidMount () {
    const {
      id,
      consultaCoem,
      change: formChange
    } = this.props
    this.props.getConsultaCoem(id, this.props.change)
    // Actualizar los datos de Exportadores
    this.props.actualizarExportadoresEnFormulario(id)
    formChange('idCoem', id)
    if (consultaCoem && consultaCoem.fechaDeEmbarque === null) formChange('fechaEmbarque', moment().format('YYYY-MM-DD[T]HH:mm'))
    //Falta agregar exportador
  }

  updateCierreCumplido (e, checked) {
    const { change: formChange } = this.props
    console.log('cierre', e, checked)
    this.props.updateCierreCumplido(checked)
    formChange('cierreCumplidoSwitch', checked)
  }

  //item 1
  changeEmbarque (e) {
    const { change: formChange } = this.props
    formChange('fechaEmbarque', e.target.value)
  }

  renderExportadores = () => {
    const {
      caratulaExportador
    } = this.props
  
    const options = caratulaExportador.map((exportador, index) => {

      return (
        <option
          value={parseEntityId(exportador)}
          key={index + 1}
        >
          {exportador}
        </option>
      )
    })
    options.unshift((<option value={null} key={0} />))
    return options
  }

  onSelect = (exportador) => {
    // const label = options[options.selectedIndex].label
    if (exportador) {
      console.log('Exportador Selecionado', exportador.target.value)
      this.props.actualizarExportadorSelecionado(exportador.target.value)
    }
  }

  render () {
    const {
      handleClose,
      handleSubmit,
      cierreCumplido,
      consultaCoem,
      selectedExportador
    } = this.props

    return (
      <div>
        <Card style={{ border: 'none' }}>
          <Card.Header style={{ backgroundColor: '#3f51b5', color: '#ffffff' }}>
            <Card.Text style={{ fontSize: '1.3rem', textAlign: 'center' }}>Edición de COEM</Card.Text>
          </Card.Header>
          <Card.Body>
            {!consultaCoem && <div className='circular-progress-consulta-soap' >
              <CircularProgress />
            </div> }
            {consultaCoem && <div>
              <CamposCoemCierreDeCarga
                renderExportadores={this.renderExportadores}
                onSelect={this.onSelect}
                selectedExportador={selectedExportador}
                updateCierreCumplido={this.updateCierreCumplido}
                cierreCumplido={cierreCumplido}
                changeEmbarque={this.changeEmbarque}
                fechaEmbarque={consultaCoem.fechaDeEmbarque}
              />
            </div>}
          </Card.Body>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button style={{ margin: '2%' }} onClick={handleClose} >Cancelar</Button>
            <Button style={{ margin: '2%' }} onClick={handleSubmit} >Guardar</Button>
          </div>
        </Card>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    consultaCoem: state.comunicacionEmbarque.consultaCoem,
    cierreCumplido: state.comunicacionEmbarque.cierreCumplido,
    selectedExportador: state.comunicacionEmbarque.selectedExportador,
    caratulaExportador: state.comunicacionEmbarque.caratulaExportador,
    idCoem: selector(state, 'idCoem'),
    fechaEmbarque: selector(state, 'fechaEmbarque'),
    fechaEmbarque2: selector(state, 'fechaEmbarque2'),
    fechaEmbarque3: selector(state, 'fechaEmbarque3'),
    fechaEmbarque4: selector(state, 'fechaEmbarque4'),
    cierreCumplidoSwitch: selector(state, 'cierreCumplido')
  }
}

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_EDICION_COEM,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: true,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(DialogoCOEMsUpdate))
